import React, { useState, useEffect } from 'react';
import { ServerErrorMessage } from '../../../../../../shared/utils/error';
import AuxiliaresScreen from './screen';
import { AuxiliaresAdapter, Auxiliar } from '../../../../../../infraestructure/persistence/rest/AuxiliaresAdapter';
import { useNotifications} from '../../../../../../shared/hooks/Notifications';

export const AuxiliaresContainer = () => {

	const api = new AuxiliaresAdapter();
	const {resultError, exceptionError, launchNotification} = useNotifications();
	let [ auxiliares, setAuxiliares ] = useState<any>([]);
	let result: any;

	useEffect(() => {
		getAuxiliares();
	}, []);

	useEffect(() => {}, [ auxiliares ]);

	const getAuxiliares = async () => {
		try {
			result = await api.ListarAuxiliares();
			if(result.data && result.data!=="")
			{
				setAuxiliares([ ...result.data ] || []);
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
	};

	const createAuxiliar = async (newAuxiliar: Auxiliar) => {
		try {
			result = await api.CrearAuxiliar(newAuxiliar);
			if(result.data && result.data!=="")
			{
				setAuxiliares([ ...auxiliares,...result.data ] || []);
				launchNotification({type:"success",title:"Creación",message:"Se ha creado un nuevo auxiliar."})
			}else{resultError()}
		} catch (e) {
			let exception = ServerErrorMessage(e);
			exceptionError(exception)
		}
	};

	const deleteAuxiliar = async (auxiliar: any) => {
		try {
			result = await api.EliminarAuxiliar(auxiliar);
			if(result.data && result.data!=="")
			{
				let pos = auxiliares.findIndex((a: Auxiliar) => a.vehiculo === auxiliar.vehiculo && a.auxiliar === auxiliar.auxiliar);
				let newData = [ ...auxiliares ];
				newData.splice(pos, 1);
				setAuxiliares([ ...newData ] || []);
				launchNotification({type:"success",title:"Eliminación",message:"Se ha eliminado una auxiliar."})
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
	};

	const updateAuxiliar = async (auxiliarOld: Auxiliar, auxiliarNew: Auxiliar) => {
		const dataUpdate = {...{vehiculoOld: auxiliarOld.vehiculo, auxiliarOld: auxiliarOld.auxiliar},...auxiliarNew}
		try {
			result = await api.ModificarAuxiliar(dataUpdate);
			if(result.data && result.data!=="")
			{
				let pos = auxiliares.findIndex((a: Auxiliar) => (a.vehiculo === auxiliarOld.vehiculo) && (a.auxiliar === auxiliarOld.auxiliar));
				let newData = [ ...auxiliares ];
				newData[pos] = result.data[0];
				setAuxiliares([ ...newData ] || []);
				launchNotification({type:"success",title:"Modificación",message:"Se ha modificado un auxiliar."})
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
	};

	

	return (
		<>
			<AuxiliaresScreen 
			data={auxiliares}
			handleCreate={createAuxiliar}
			handleUpdate={updateAuxiliar}
			handleRemove={deleteAuxiliar}
			/>
		</>
	);
};

export default AuxiliaresContainer;
